import { Injectable } from '@angular/core';
import { HttpClient } from '@angular/common/http';
import { AppConfig } from '../../config';
import { map } from 'rxjs/operators';

@Injectable({
  providedIn: 'root',
})
export class PregledIzdatniceService {
  constructor(private _http: HttpClient) {}

  dohvatiIzdatnice(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_izdatnice', a)
      .pipe(map((res: any) => res));
  }

  dohvatiJednuIzdatnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'dohvati_jednu_izdatnicu', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkePopis(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkePopis', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeDodaj(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeDodaj', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeUredi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeUredi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaZavrsi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnicaZavrsi', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'izdatnicaObrisi', a)
      .pipe(map((res: any) => res));
  }

  tmpprometstavkeObrisi(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'tmpprometstavkeObrisi', a)
      .pipe(map((res: any) => res));
  }

  artiklPopisZaPoslovnicu(a: any) {
    return this._http
      .post(AppConfig.ipAddress + 'artiklPopisZaPoslovnicu', a)
      .pipe(map((res: any) => res));
  }

  izdatnicaStorno(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnica_storno', a)
      .pipe(map((res: any) => res));
  }

  vrstaposlovnicePopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'vrstaposlovnicePopis', a)
      .pipe(map((res: any) => res));
  }

  poslovnicaPopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'poslovnicaPopis', a)
      .pipe(map((res: any) => res));
  }

  planproizvodnjePopis(a: any) {
    return this._http.post(AppConfig.ipAddress + 'planproizvodnje_prikaz', a)
      .pipe(map((res: any) => res));
  }
  
  izdatnicaDodajZaPlan(a: any) {
    return this._http.post(AppConfig.ipAddress + 'izdatnicaDodajZaPlan', a)
      .pipe(map((res: any) => res));
  }
}
